/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Foot_Pedal_SetupInputs */

const en_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foot Pedal Setup`)
};

const fr_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration de la pédale`)
};

const de_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fußpedal-Setup`)
};

const it_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazione del pedale`)
};

const ru_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка ножной педали`)
};

const es_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración del pedal`)
};

const zh_cn2_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脚踏板设置`)
};

const ja_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フットペダルのセットアップ`)
};

const hi_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फुट पेडल सेटअप`)
};

const pt_pt2_foot_pedal_setup = /** @type {(inputs: Foot_Pedal_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração do pedal`)
};

/**
* | output |
* | --- |
* | "Foot Pedal Setup" |
*
* @param {Foot_Pedal_SetupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const foot_pedal_setup = /** @type {((inputs?: Foot_Pedal_SetupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Foot_Pedal_SetupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_foot_pedal_setup(inputs)
	if (locale === "de") return de_foot_pedal_setup(inputs)
	if (locale === "it") return it_foot_pedal_setup(inputs)
	if (locale === "ru") return ru_foot_pedal_setup(inputs)
	if (locale === "es") return es_foot_pedal_setup(inputs)
	if (locale === "zh-CN") return zh_cn2_foot_pedal_setup(inputs)
	if (locale === "ja") return ja_foot_pedal_setup(inputs)
	if (locale === "hi") return hi_foot_pedal_setup(inputs)
	if (locale === "pt-PT") return pt_pt2_foot_pedal_setup(inputs)
	return en_foot_pedal_setup(inputs)
});